<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Service Names for Me'"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Customize how service names appear to you. These names will be shown in your checklists, schedule, and reports. Note: This is different from service names for pros, which you can edit in pro settings.'" />
      </tidy-row>

      <tidy-alert class="green-background">
        <tidy-row>
          <tidy-image [src]="'assets/svg/information-circle-outline.svg'" />
          <tidy-text [body]="'Changes will be saved automatically.'" />
        </tidy-row>
      </tidy-alert>

      @if (errorMessage) {
        <tidy-alert>
          <tidy-text [body]="errorMessage" />
        </tidy-alert>
      }

      @if (services && services.length > 0) {
        <tidy-card>
          <ion-row>
            <ion-col style="flex: 1;">
              <tidy-text [header]="'Original Name'" />
            </ion-col>
            <ion-col style="flex: 1;">
              <tidy-text [header]="'Your Name (How You See It)'" />
            </ion-col>
          </ion-row>
        </tidy-card>

        <form [formGroup]="form">
          @for (service of services; track service.id) {
            <tidy-card>
              <ion-row>
                <ion-col style="flex: 1; display: flex; align-items: center;">
                  <tidy-text
                    [body]="service.originalName" />
                </ion-col>
                <ion-col style="flex: 1;">
                  <tidy-input
                    [formControlName]="'service_' + service.id"
                    [icon]="'assets/svg/pencil.svg'"
                    [form]="form.get('service_' + service.id)"
                    [label]="'Your Custom Name'" />
                </ion-col>
              </ion-row>
            </tidy-card>
          }
        </form>
      } @else {
        <tidy-alert>
          <tidy-text [body]="'No services found.'" />
        </tidy-alert>
      }
    } @else {
      <tidy-loader />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
